import {useI18n} from '@logistics-frontend/core/i18n'
import {get} from '@logistics-frontend/utils'
import {RequirementOption, SupportedRequirement} from '@yandex-taxi/js-integration-api'
import {useRequirementValue} from '@yandex-taxi/react-integration-api'
import {useStoreContext} from '@yandex-taxi/react-integration-api/build/module/components/Context'
import {useCallback, useEffect, useMemo} from 'react'

export const useRequirementOptionsWithDefault = (
  requirement: SupportedRequirement,
): RequirementOption[] | undefined => {
  const t = useI18n()

  const defaultTitle: Record<string, string> = useMemo(
    () => ({
      cargo_loaders: t('order.form.requirements.no_loaders', 'Без грузчиков'),
    }),
    [t],
  )

  const createDefaultOption = useCallback(
    (requirement: SupportedRequirement): RequirementOption => ({
      label: '',
      value: requirement.default,
      name: `default_${requirement.name}`,
      title: defaultTitle[requirement.name] || t('order.form.requirements.not_chosen', 'не выбрано'),
    }),
    [defaultTitle, t],
  )

  return useMemo(() => {
    const mayBeOptions = requirement.select?.options

    if (mayBeOptions) {
      const defaultOption = createDefaultOption(requirement)

      if (mayBeOptions.some(o => o.value === defaultOption.value)) {
        return mayBeOptions
      }

      // бывают ситуации, когда значение по умолчанию не присутствует в опциях
      // если их там нет, то нужно добавить, чтобы получить нормальный селект
      return [defaultOption].concat(mayBeOptions)
    }
  }, [requirement, createDefaultOption])
}

export const useDefaultCargoTypeRequirement = (name: string, options: RequirementOption[]) => {
  const [{value}, {setValue}] = useRequirementValue(name)
  const [store] = useStoreContext()
  const requirements = store.draft.values.requirements
  const defaultOption = value ? undefined : requirements?.initial?.cargo?.[name] || get('[0].value', options)

  useEffect(() => {
    if (defaultOption) {
      setValue(defaultOption)
    }
  }, [requirements, defaultOption, setValue])
}
